import muster from '@dbk-legacy/muster';
import lget from 'lodash/get';

import ui from '../../../data/ui.json';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';

export default () =>
  muster()
    .match('app.user.profile[{integers:profileListIndex}].*', {
      get(requests) {
        return Promise.all(
          requests.map(({ req, res }) =>
            res.value(
              lget(
                ui,
                `profile.options[${req.params.profileListIndex}][${
                  req.params['*']
                }]`
              )
            )
          )
        );
      },
    })
    .path('app.user.profile.length', ({ res }) =>
      res.value(ui.profile.options.length)
    )
    .match('app.user.profile.security[{integers:profileListIndex}].*', {
      get(requests) {
        return Promise.all(
          requests.map(({ req, res }) =>
            res.value(
              lget(
                ui,
                `profile.security[${req.params.profileListIndex}][${
                  req.params['*']
                }]`
              )
            )
          )
        );
      },
    })
    .path('app.user.profile.security.length', ({ res }) =>
      res.value(ui.profile.security.length)
    )
    .match('app.user.profile.portfolio[{integers:profileListIndex}].*', {
      get(requests) {
        return Promise.all(
          requests.map(({ req, res }) =>
            res.value(
              lget(
                ui,
                `profile.portfolio[${req.params.profileListIndex}][${
                  req.params['*']
                }]`
              )
            )
          )
        );
      },
    })
    .path('app.user.profile.portfolio.length', ({ res }) =>
      res.value(ui.profile.portfolio.length)
    )
    .path('app.user.profile.showPmtTxLimitMsg',variable(false))
    .path('app.user.profile.paymentTxLimit', variable(null));
